import { __assign, __extends } from "tslib";
import * as React from 'react';
import Buttton from '../../../Button';
import classnames from 'classnames';
import * as s from './FooterButton.scss';
var FooterButton = /** @class */ (function (_super) {
    __extends(FooterButton, _super);
    function FooterButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FooterButton.prototype.render = function () {
        return (React.createElement(Buttton, __assign({}, this.props, { className: classnames(s['footer-btn'], this.props.className) })));
    };
    return FooterButton;
}(React.Component));
export default FooterButton;
//# sourceMappingURL=FooterButton.js.map